module.exports = __webpack_public_path__ + "static/media/krystal_maughan_bai.f9fbe860.png";